module.exports = __webpack_public_path__ + "img/Rectangle Copy 18@2x.df6fea07.png";